const o = {namespaced: true};
import TaskManager from '@/components/task2/TaskManager';
const tm = new TaskManager();

o.state = {
  ready: false,
  selection: [],
  can_undo: false,
  can_redo: false,
  tasks: [],
};

o.getters = {
  tasks(state) {
    return (state.tasks);
  },
  canUndo(state) {
    return state.undo;
  },
  canRedo(state) {
    return state.redo;
  },
};


o.actions = {
  load({commit}) {
    commit('load');
  },
  do({commit}, {action, params}) {
    commit('do', {action, params});
  },
  undo({commit}) {
    commit('undo');
  },
  redo({commit}) {
    commit('redo');
  },
  save({commit}) {
    commit('save');
  },
};

function render(state) {
  const {tasks, can_undo, can_redo} = tm.render();
  state.tasks = tasks;
  state.can_undo = can_undo;
  state.can_redo = can_redo;
}
o.mutations = {
  do(state, {action, params}) {
    tm.do(action, params);
    render(state);
    tm.save();
  },
  undo(state, {action, params}) {
    tm.undo(action, params);
    state.tasks = tm.render();
    tm.save();
  },
  redo(state, {action, params}) {
    tm.redo(action, params);
    render(state);
    tm.save();
  },
  load(state) {
    tm.load();
    render(state);
    console.log('任务管理工具初始化完毕');
  },
  save(state) {
    tm.save();
  },
};

export default o;
